import React from 'react';

import { ColumnShimmer } from '../../ColumnShimmer';

export const TaxImpactGainLossLoading: React.FC = () => {
  return <ColumnShimmer columns={2} data-testid="tax-impact-gain-loss-shimmer" />;
};
